const translations = {
  "en": {
    "Please enter the correct email": "Please enter the correct email",
    "Please enter the email address": "Please enter the email address"
  },
  "zh-tw": {
    "Please enter the correct email": "請輸入正確的電子郵件",
    "Please enter the email address": "請輸入電子郵件地址"
  }
};

export default translations;
